import styled, { css, keyframes } from 'styled-components'

const highlightPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(62, 207, 142, 0.45);
  }
  40% {
    box-shadow: 0 0 0 4px rgba(62, 207, 142, 0.2);
  }
  100% {
    box-shadow: 0 0 0 0 transparent;
  }
`

/** Shared page width for settings / help / account flows. */
export const PageStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  margin-top: 1rem;
  width: 100%;
  max-width: ${({ $fullWidth }) => ($fullWidth ? 'none' : '720px')};
`

export const Panel = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.15rem 1.25rem 1.35rem;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.background};
  /* Leave room for the fixed header when scrolling to anchors */
  scroll-margin-top: 88px;
  transition: border-color 0.35s ease, background-color 0.35s ease,
    box-shadow 0.35s ease;

  ${({ $highlighted, theme }) =>
    $highlighted &&
    css`
      border-color: ${theme.colors.action.primary.bg};
      background: ${theme.name === 'dark'
        ? 'rgba(62, 207, 142, 0.12)'
        : 'rgba(62, 207, 142, 0.06)'};
      animation: ${highlightPulse} 1.6s ease-out 2;
    `}

  @media (max-width: 768px) {
    padding: 1rem 1.05rem 1.15rem;
    border-radius: 10px;
  }
`

export const PanelTitle = styled.h2`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const PanelBody = styled.p`
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.55;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const PanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`
